function defineViewProperties(store, getState, views) {
	Object.entries(views).forEach(([key, getter]) => {
		Object.defineProperty(store, key, {
			enumerable: true,
			get() {
				return getter(getState());
			},
		});
	});

	return store;
}

/**
 * @author mcg
 */
export function createStore(state, views = {}) {
	Object.freeze(state);
	const callbacks = [];
	let lastDispatchFinished;

	const store = {
		getState: () => state,
		subscribe: Array.prototype.push.bind(callbacks),
		dispatch(action, payload) {
			if (typeof action !== "function") {
				throw new Error("FATAL: action is not a function");
			}

			let dispatchFinished;
			const preparedAction = state => {
				return action(
					state,
					payload,
					store.dispatch,
					defineViewProperties({}, () => state, views),
				);
			};

			const previousUpdateDone = lastDispatchFinished
				? new Promise(resolver => {
						lastDispatchFinished.then(state => {
							setTimeout(() => {
								resolver(state);
							}, 0);
						});
					})
				: Promise.resolve(state);

			dispatchFinished = previousUpdateDone.then(preparedAction);
			lastDispatchFinished = dispatchFinished;

			// Update with new state.
			dispatchFinished.then(nextState => {
				if (nextState === state) {
					// Update is not wanted, just bail out
					return state;
				}
				state = Object.freeze(nextState);
				callbacks.forEach(callback => {
					callback(state, store);
				});
				return state;
			});

			// Drop promise reference if last in chain.
			dispatchFinished.finally(() => {
				if (dispatchFinished === lastDispatchFinished) {
					lastDispatchFinished = null;
				}
			});

			return lastDispatchFinished;
		},
	};

	defineViewProperties(store, store.getState, views);

	return Object.freeze(store);
}
